import { useEffect, useState } from "react";
import { COUNTDOWN_SECONDS, MIN_SPOTS_LEFT, STARTING_SPOTS_LEFT } from "../data/offer";

// Shared start time so every timer and scarcity bar on the page stays in sync
const PAGE_START = Date.now();

function compute() {
  const elapsed = Math.floor((Date.now() - PAGE_START) / 1000);
  const remaining = COUNTDOWN_SECONDS - (elapsed % COUNTDOWN_SECONDS);
  const spotsLeft = Math.max(MIN_SPOTS_LEFT, STARTING_SPOTS_LEFT - Math.floor(elapsed / 75));
  return { remaining, spotsLeft };
}

export function useOfferClock() {
  const [state, setState] = useState(compute);

  useEffect(() => {
    const id = window.setInterval(() => setState(compute()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const hours = Math.floor(state.remaining / 3600);
  const minutes = Math.floor((state.remaining % 3600) / 60);
  const seconds = state.remaining % 60;

  return { ...state, hours, minutes, seconds };
}
